$(document).ready(function() {
  $('#add-to-cart-button').on('click', function(event) {
    event.preventDefault();
    var productIds = [];
        $('.upsell-product').each(function() {
      var productId = $(this).attr('varitID');
      if (productId) {
        productIds.push(productId);
      }
    });
    if (productIds.length === 0) {
      alert('No products selected for the cart.');
      return;
    }

    var itemsToAdd = productIds.map(function(id) {
      return { id: id, quantity: 1 };
    });
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(response => response.json())
    .then(() => {
      $.ajax({
        url: "/cart",
        dataType: "HTML",
        success: function(data) {
          console.log(data);
            fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble")
            .then(request => request.text())
            .then(response => {
            const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
            const bubble = document.querySelector('#cart-icon-bubble');
            bubble.innerHTML = bubbleHTML;
            });

          fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
            .then(res => res.text())
            .then(data => {
              const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
              const drawer = document.querySelector('cart-drawer');
              drawer.innerHTML = newHTML;
              drawer.classList.contains('is-empty') ? drawer.classList.remove('is-empty') : drawer.classList.remove('is-empty');
            });

          setTimeout(function() {
            $('body').addClass('overflow-hidden');
            $('.drawer').addClass('animate active');
          }, 400);
        }
      });
    })
    .catch(error => {
      console.error('Error adding products to cart:', error);
      alert('error.');
    });
  });
});
